import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPaymentItem.Save.IRequest;
type Response = Api.Finance.ContractRefundPaymentItem.Save.IResponse;
type Headers = Api.Finance.ContractRefundPaymentItem.Save.IHeaders;
const url = '/api/Finance/ContractRefundPaymentItem';
export default async function contractRefundPaymentItemSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
